export const shortDate = str => new Date(str).toLocaleDateString('en-US');
// "12/16/2019"

const shortDate2Opts = {
  year: 'numeric',
  month: 'short',
  day: 'numeric',
};

export const shortDate2 = str =>
  new Date(str).toLocaleDateString('en-US', shortDate2Opts);
// "Dec 16, 2019"

const mediumDateOpts = {
  weekday: 'short',
  year: 'numeric',
  month: 'short',
  day: 'numeric',
};

export const mediumDate = str =>
  new Date(str).toLocaleDateString('en-US', mediumDateOpts);
// "Wed, Dec 16, 2019"

const longDateOpts = {
  weekday: 'long',
  year: 'numeric',
  month: 'long',
  day: 'numeric',
};

export const longDate = str =>
  new Date(str).toLocaleDateString('en-US', longDateOpts);
// "Wednesday, December 16, 2019"
